<template>
  <v-row
      no-gutters
      style="height: 100%;"
  >
    <v-col cols="6">
      <v-card
          v-if="(!getDivisaoQuadroAtualLoop(1) || !getDivisaoQuadroAtualLoop(1).componenteTipo)
            && (exibindoEm == 'selecionaLayout' || exibindoEm == 'areaEdicao')"
          style="border: 2px grey dashed"
          class="fill-height"
      >
        <v-card-text
            justify="center"
        >
          <p class="text-h5" align="center">
            Layout tipo 2
          </p>
          <div v-if="exibindoEm == 'areaEdicao'">
            <p
                class="text-h6"
                align="center"
            >
              Adicione um componente clicando no ícone abaixo.
            </p>

            <SelecionaComponente
                :divisao-layout=1
            ></SelecionaComponente>
          </div>
        </v-card-text>
      </v-card>
      <div
          v-if="getDivisaoQuadroAtualLoop(1) && getDivisaoQuadroAtualLoop(1).componenteTipo"
          @mousedown="setDivisaoNumeroEmEdicao(1)"
          :class="($store.state.timelineStore.layoutDivisaoNumeroEmEdicao == 1 && exibindoEm != 'player' ? 'divisaoEmEdicaozzz' : '')"
          style="width: 100%; height: 100%;"
      >
        <TabelaPreco
            v-if="getDivisaoQuadroAtualLoop(1) && getDivisaoQuadroAtualLoop(1).componenteTipo == 'tabela-preco'"
            :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(1)
        ></TabelaPreco>

        <Cartaz
            v-if="getDivisaoQuadroAtualLoop(1) && getDivisaoQuadroAtualLoop(1).componenteTipo == 'cartaz'"
            :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(1)
            :exibindo-em="exibindoEm"
        ></Cartaz>

      </div>
    </v-col>

    <v-col cols="6">
      <v-card
          v-if="(!getDivisaoQuadroAtualLoop(2) || !getDivisaoQuadroAtualLoop(2).componenteTipo)
            && (exibindoEm == 'selecionaLayout' || exibindoEm == 'areaEdicao')"
          style="border: 2px grey dashed"
          class="fill-height"
      >
        <v-card-text
            justify="center"
        >
          <p class="text-h5" align="center">
            Layout tipo 2
          </p>
          <div v-if="exibindoEm == 'areaEdicao'">
            <p
                class="text-h6"
                align="center"
            >
              Adicione um componente clicando no ícone abaixo.
            </p>

            <SelecionaComponente
                :divisao-layout=2
            ></SelecionaComponente>
          </div>
        </v-card-text>
      </v-card>
      <div
          v-if="getDivisaoQuadroAtualLoop(2) && getDivisaoQuadroAtualLoop(2).componenteTipo"
          @mousedown="setDivisaoNumeroEmEdicao(2)"
          :class="($store.state.timelineStore.layoutDivisaoNumeroEmEdicao == 1 && exibindoEm != 'player' ? 'divisaoEmEdicaozzz' : '')"
          style="width: 100%; height: 100%;"
      >
        <TabelaPreco
            v-if="getDivisaoQuadroAtualLoop(2) && getDivisaoQuadroAtualLoop(2).componenteTipo == 'tabela-preco'"
            :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(2)
        ></TabelaPreco>

        <Cartaz
            v-if="getDivisaoQuadroAtualLoop(2) && getDivisaoQuadroAtualLoop(2).componenteTipo == 'cartaz'"
            :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(2)
            :exibindo-em="exibindoEm"
        ></Cartaz>

      </div>
    </v-col>

  </v-row>
</template>

<script>
import SelecionaComponente from "../components/SelecionaComponente";
import TabelaPreco from "../components/TabelaPreco";
import Cartaz from "../components/Cartaz";
import {timelineMixin} from "../timelineMixin";

export default {
  name: "layout2",
  components: {Cartaz, TabelaPreco, SelecionaComponente},
  data: () => ({
    layoutTipo: 2,
  }),
  mixins: [timelineMixin],
}
</script>

<style scoped>
</style>
